import { useQuery } from "@tanstack/react-query"
import { Col, Row, Select } from "antd"
import { DefaultOptionType, SelectProps } from "antd/es/select"
import { filterOption } from "components/inputs/helpers"
import { Text } from "components/UI"
import api from "helpers/api"
import { Uuid } from "types"
import { ListingResponse } from "types/api"
import { SelectEntity } from "../types"
import { getOnSelectData } from "./onSelect"

interface SeriesSelectProps {
    activeSeries: SelectEntity | null
    setActiveSeries: (v: SelectEntity | null) => void
    activeProducerId?: Uuid
    activeGroupId?: Uuid
    required?: boolean
    layout?: "vertical" | "horizontal"
    size?: SelectProps["size"]
}

export function SeriesSelect({
    activeSeries,
    setActiveSeries,
    required,
    activeProducerId,
    activeGroupId,
    layout = "horizontal",
    size,
}: SeriesSelectProps) {
    const { data, isLoading, isFetching } = useQuery<DefaultOptionType[]>({
        queryKey: [activeProducerId, activeGroupId],
        enabled: !!activeProducerId && !!activeGroupId,
        queryFn: () =>
            api
                .getTyped<ListingResponse>("listing/series", {
                    producer: activeProducerId,
                    method: "asc",
                    sort: "name",
                    itemsGroup: activeGroupId,
                    count_on_page: Number.MAX_SAFE_INTEGER,
                })
                .then((response) => {
                    return response.entities.map(
                        (el) =>
                            ({
                                label: el.fields.find(
                                    (field) => field.name === "name"
                                )!.value,
                                value: el.fields.find(
                                    (field) => field.name === "id"
                                )!.value,
                            } as DefaultOptionType)
                    )
                }),
        initialData: [],
    })

    const labelSpan = layout === "horizontal" ? 5 : 24
    const inputSpan = layout === "horizontal" ? 19 : 24

    const onChange = (v: any) => {
        setActiveSeries(v ? getOnSelectData(v) : null)
    }

    return (
        <Row gutter={[0, 10]}>
            <Col xs={24} md={labelSpan}>
                <Text.FormLabel required={required}>Серия</Text.FormLabel>
            </Col>
            <Col xs={24} md={inputSpan}>
                <Select
                    size={size}
                    loading={isLoading || isFetching}
                    className="fw"
                    placeholder="Выберите серию"
                    showSearch
                    filterOption={filterOption}
                    options={data}
                    value={activeSeries}
                    onChange={(_, option: any) => onChange(option)}
                    allowClear
                    disabled={!activeProducerId}
                />
            </Col>
        </Row>
    )
}
